import React from 'react'
import { numericFormatter } from 'react-number-format'
import { useSelector } from 'react-redux'
import { Typography } from '@material-ui/core'
import moment from 'moment'
import { PRICE_FORMAT } from 'utils/constants'
import { timeFormat } from 'utils/functions'

import { useStyles } from './InstallmentCard.style'

const InstallmentCard = ({ installment, hiddenTime }) => {
  const classes = useStyles()

  const { activeInscriptionForm } = useSelector((state) => state.events)

  const firstInstallment = installment.number === 1

  const isFree = installment.amount === 0
  const finalAmount = !isFree
    ? numericFormatter(Number(installment.amount).toString(), {
        ...PRICE_FORMAT,
        fixedDecimalScale: !Number.isInteger(installment.amount)
      })
    : 'Bonificado'

  return (
    <div>
      <Typography className={classes.title} color='primary' variant='h6'>
        Cuota N° {installment.number}
      </Typography>

      {installment.discountApplied > 0 && (
        <Typography className={classes.amount}>
          Precio:&nbsp;
          <span className={classes.originalPrice}>
            {numericFormatter(Number(installment.originalAmount).toString(), {
              ...PRICE_FORMAT,
              fixedDecimalScale: !Number.isInteger(installment.originalAmount)
            })}
          </span>
        </Typography>
      )}

      {installment.discountApplied > 0 && (
        <Typography className={classes.discount}>
          Descuento aplicado:&nbsp;
          <span>
            {numericFormatter(Number(installment.discountApplied).toString(), {
              ...PRICE_FORMAT,
              fixedDecimalScale: !Number.isInteger(installment.discountApplied)
            })}
          </span>
        </Typography>
      )}

      <Typography className={classes.amount}>
        Monto a pagar:&nbsp;
        <span>{finalAmount}</span>
      </Typography>

      {!isFree && (
        <Typography className={classes.date}>
          Se podrá pagar a partir de:&nbsp;
          {firstInstallment ? (
            'Enviar la inscripción'
          ) : (
            <span>{moment(installment.startDate).format('DD/MM/YYYY')}</span>
          )}
        </Typography>
      )}

      {!isFree && (
        <Typography className={classes.date}>
          Fecha de vencimiento:&nbsp;
          <span>
            {activeInscriptionForm.paymentConfirmationPeriod && firstInstallment
              ? `Dentro de ${
                  timeFormat(activeInscriptionForm.paymentConfirmationPeriod).split(':')[0]
                }hs`
              : moment(installment.endDate).format(hiddenTime ? 'DD/MM/YYYY' : 'DD/MM/YYYY HH:mm')}
          </span>
        </Typography>
      )}
    </div>
  )
}

export default InstallmentCard
